// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__2xwSw","header":"PatientQuestionnaire_header__UwBWV","info":"PatientQuestionnaire_info__3y5np"};